/*
 * @Description: 按钮、字段权限
 * @Date: 2024-11-18 14:25:31
 */

import { ref } from 'vue';
import { defineStore } from 'pinia';
import { Resource } from '@cTypes/user';
import { resourceList } from '@/common/data-source/user/apis';

const name = 'useResourceStoreSetup';
const useSetup = defineStore(
  name,
  () => {
    const resource = ref<Resource[] | []>([]);
    async function setResource(id) {
      const { data } = await resourceList({ id });
      resource.value = data;
      return Promise.resolve();
    }

    return { resource, setResource };
  },
  {
    persist: true
  }
);

export { useSetup, name };
